module.exports = __webpack_public_path__ + "img/bg2.1a86371d.jpg";